import { InspectFWA } from './pages/inspect.js'
import { fraudWasteAbuseAllegation, hhsEmployeeType } from '../../../choices'
import {
  allegationPage,
  commonPageSequence,
  employeePage,
  employeeTypePage,
  hhsProgramsPage,
  retaliatedAgainstPage,
  reviewPage
} from '../../../pages'

export const formSchema = saveComplaint => {
  const initialPages = [
    allegationPage({ choices: fraudWasteAbuseAllegation() }),
    hhsProgramsPage()
  ]
  const finalPages = [
    employeePage({
      gotoPageYes: 'employee_type_page',
      gotoPageNo: 'review_page'
    }),
    employeeTypePage({ choices: hhsEmployeeType() }),
    retaliatedAgainstPage(),
    reviewPage(InspectFWA)
  ]

  return {
    title: 'Fraud, Waste or Abuse Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: initialPages.concat(
      commonPageSequence({ includeVictim: false }),
      finalPages
    )
  }
}
